import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=e66212b8&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e66212b8')) {
      api.createRecord('e66212b8', component.options)
    } else {
      api.reload('e66212b8', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=e66212b8&", function () {
      api.rerender('e66212b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2MoLBS243NdfA/JS/comp/childrenage.vue"
export default component.exports